export default "__VITE_ASSET__BNsOKEeI__"